import './partials/register-service-worker';
import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init({
  bgColor: '#00205b'
});

// Legacy
import './partials/helpers';
import './partials/webshop';

// New modules
import './polyfills';
import './utilities';

window.stageLanguage = document.documentElement.getAttribute('lang');

// Get extranet user info
import { loadUserData } from './modules/user';
loadUserData();

import header from './modules/header';
header.init();

import footer from './modules/footer';
footer.init();

// Load CSRF token & update for every form (because of page cache)
import { loadToken } from './modules/forms';
loadToken();

const lazyLoads = document.querySelectorAll('.lazyload');
if(lazyLoads.length) {
  import('lazyload').then(module => {
    new module.default(null, {
      rootMargin: '0px',
      selector: '.lazyload',
      src: 'data-original',
      threshold: 0
    });
  })
}

// Accordion elements
const accordionElements = document.getElementsByClassName('js-accordion');
if (accordionElements.length) {
  import('./modules/accordion').then(({ Accordion }) => {
    for (var i = 0; i < accordionElements.length; i++) {
      new Accordion(accordionElements[i]);
    }
  });
}

// Stage form errors
// Scroll to start of the form on stage form errors
const stageFormErrors = document.querySelector('.stage-form.stage-error')
if (stageFormErrors) {
  import('./modules/helpers').then( ({scrollToElement}) => {
    scrollToElement(stageFormErrors)
  })
}

// Newsletter form elements
const newsletterFormElements = document.getElementsByClassName('js-newsletter-form');
if (newsletterFormElements.length) {
  import('./modules/newsletter').then(({ NewsletterForm }) => {
    for (var i = 0; i < newsletterFormElements.length; i++) {
      new NewsletterForm(newsletterFormElements[i]);
    }
  });
}

// Init image carousels
const imageCarousels = document.getElementsByClassName('js-image-carousel');
if (imageCarousels.length) {
  import('./modules/image-carousel').then(({ ImageCarousel }) => {
    for (var i = 0; i < imageCarousels.length; i++) {
      new ImageCarousel(imageCarousels[i], {
        autoplay: {
          delay: 5000,
        },
        effect: 'fade',
        fadeEffect: { crossFade: true },
        simulateTouch: true,
        loop: true,
        speed: 500,
        pagination: true
      });
    }
  });
}

// Product carousels
const imageGalleryCarousels = document.getElementsByClassName('js-image-gallery-carousel');
if (imageGalleryCarousels.length) {
  import('./modules/image-gallery-carousel').then(({ imageGalleryCarousel }) => {
    for (var i = 0; i < imageGalleryCarousels.length; i++) {
      new imageGalleryCarousel(imageGalleryCarousels[i], { navigation: true });
    }
  });
}

// Product carousels
const productCarousels = document.getElementsByClassName('js-product-carousel');
if (productCarousels.length) {
  import('./modules/product-carousel').then(({ ProductCarousel }) => {
    for (var i = 0; i < productCarousels.length; i++) {
      new ProductCarousel(productCarousels[i], {});
    }
  });
}

// Video lift elements
const videoLiftElements = document.getElementsByClassName('js-video-lift-trigger');
if (videoLiftElements.length) {
  import('./modules/video-lift').then(({ Videolift }) => {
    for (var i = 0; i < videoLiftElements.length; i++) {
      new Videolift(videoLiftElements[i]);
    }
  });
}

// Product page
const productPage = document.getElementsByClassName('p-product-page');
if (productPage.length) {
  import('./partials/track-page');
  import('./modules/product').then(({ ProductPage }) => {
    new ProductPage(productPage[0]);
  });
}


// Really legacy

// Should be updated
if (window.location.hash || (document.location.search && document.location.search.indexOf('snc=1') !== -1) || document.querySelector('.form.stage-error, form .has-error')) {
  import('./partials/scroll-pos');
}

if (document.querySelector('.products-grid')) {
  import('./partials/product-list');
}

if (document.querySelector('.js-quantity-selector')) {
  import('./partials/quantity-selector');
}

if (document.querySelector('.js-sticky-subnav-parent')) {
  import('./partials/sticky-subnav');
}

if (document.querySelector('.search-results')) {
  import('./partials/search-results');
}

import svg4everybody from './vendor/svg4everybody';
/* ------------------------------------------------------------------------- */
/*  Add SVG External Content support to all browsers
/* ------------------------------------------------------------------------- */
(function() {
  if (typeof svg4everybody === 'function') {
    svg4everybody();
  }
})();

// Not sure they exist / should not exist
if (document.querySelector('.somewall-items')) {
  import('./partials/somewall');
}

if (document.querySelector('.stage-form-label.file input[type=file]')) {
  import('./partials/file-input');
}

/*if (document.querySelector('.bed-wizard')) {
  import('./partials/bed-wizard');
}*/

/*if (document.querySelector('.campaign-products-carousel__slick-carousel')) {
  import('./partials/campaign-carousel');
}*/
